<script lang="ts">
  import { onMount } from "svelte";

  export let wait: number = 30;
  export let stopCountdown: Function = () => stop();
  export let startCountdown: Function = () => start();

  let remainTime: number = wait;
  let interval = null;
  let isFinished: boolean = false;

  function start() {
    if (interval) {
      stop();
    }

    remainTime = wait;
    isFinished = false;
    interval = setInterval(() => {
      remainTime = remainTime - 1;
      if (remainTime <= 0) {
        stop();
      }
    }, 1000);
  }

  function stop() {
    clearInterval(interval);
    interval = null;
    isFinished = true;
  }

  // onMount(() => {
  //   start();
  // });
</script>

<span>
  {#if !isFinished}
    <span class="text-primary-indigo-blue font-semibold">{remainTime} sec</span>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <span
      class="text-pink-50 hover:text-pink-100 font-semibold cursor-pointer"
      on:click
    >
      Resend Code
    </span>
  {/if}
</span>
